const getIpfsImageUrl = (hash, { width, quality } = { width: 1000, quality: 70 }) => {
  return `https://ipfs-pera.algonode.dev/ipfs/${hash}?optimizer=image&width=${width}&quality=${quality}`;
  // return `https://ipfs.algonode.dev/ipfs/${hash}?optimizer=image&width=${width}&quality=${quality}`;
};

export default getIpfsImageUrl;
